import { PathBase } from "@constellation-academy/epic-ui";

export class GenerateCartLinkPath extends PathBase {
	static readonly pathKey = "generateCartLink";
	static readonly pathName = "generate-cart-link";
}
